import { GetterTree } from "vuex";
import { IAuthState } from "./types";
import { IRootState } from "@/store/types";

export namespace AUTH_GETTERS {
  export const GET_USERNAME: string = "getUsername";
  export const GET_ASSUMED_ROLE: string = "getAssumedRole";
}

export const getters: GetterTree<IAuthState, IRootState> = {
  [AUTH_GETTERS.GET_USERNAME](state: IAuthState): string {
    return state.user && state.user.profile && state.user.profile.name;
  },
  [AUTH_GETTERS.GET_ASSUMED_ROLE](state: IAuthState): string | undefined {
    if (state.roles) {
      if (state.isAssumingRole) {
        // It is only possible to assume a single role so this is safe to do.
        return state.roles[0];
      }
    }
    return undefined;
  }
};
